'use strict';

angular.module('AdminSystemOwnerReviewControllers')

.controller('ActionOnCardsSystemOwnerController', ['$scope', '$modal', 'adminSystemOwnerReviewService', function ($scope, $modal, administrationService) {

    // Display or no actions
    $scope.displayActions = false;

    $scope.showOrHideActions = function (status, index) {
        $scope.displayActions = !$scope.displayActions;
    }

    // Go to impersonate url
    $scope.impersonateSystemOwner = function () {
        window.open('/SystemOwner/Review/' + $scope.systemOwnerAndChanges.ActiveDirectoryAccountUsername, '_blank');
    };

}]);